import ReferenceRecord from "components/Records/References/ReferenceRecord";
import useModule from "hooks/useModule";
import { useMemo } from "react";
import { Button } from "reactstrap";
import { findWhere } from "underscore";

const Field = {
  Name: "Related To",
  FieldType: "MultiReference",
  SourcesList: "Tenant.Modules.Contacts",
};

const QuickNoteRelatedTo = ({ setRelatedTo }) => {
  const { module } = useModule("Activities");

  const fieldSchema = useMemo(() => {
    if (!module?.Fields) return Field;

    const relatedToField = findWhere(module?.Fields, { APIName: "Related" });

    return relatedToField || Field;
  }, [module?.Fields]);

  return (
    <ReferenceRecord
      record={null}
      field={fieldSchema}
      onSelectedChange={onUpdateRelated}
      customDisplayComponent={
        <Button size="sm" outline>
          Related Contacts
        </Button>
      }
    />
  );

  function onUpdateRelated(selectedContacts) {
    setRelatedTo(selectedContacts);
  }
};

export default QuickNoteRelatedTo;
